import { render, staticRenderFns } from "./OrderListCard.vue?vue&type=template&id=7f183d46&scoped=true"
import script from "./OrderListCard.vue?vue&type=script&lang=js"
export * from "./OrderListCard.vue?vue&type=script&lang=js"
import style0 from "./OrderListCard.vue?vue&type=style&index=0&id=7f183d46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f183d46",
  null
  
)

export default component.exports